import type { ReactNode } from 'react';
import { View } from 'react-native';

import { Text, VStack, theme } from '@squire/ui';

import { styles } from './styles';

const PaymentMethodSection = ({
  title,
  testID,
  children,
}: {
  title: string;
  testID: string;
  children: ReactNode;
}) => (
  <View testID={testID} style={styles.section}>
    <VStack space={theme.spacing[3]}>
      <Text variant="lStrong" color="textPrimary">
        {title}
      </Text>
      <VStack space={theme.spacing[3]}>{children}</VStack>
    </VStack>
  </View>
);

PaymentMethodSection.displayName = 'PaymentMethodSection';
export { PaymentMethodSection };
